export const INITIAL_DATA_STATE = 'data-state/initial';
export const SUCCESS_DATA_STATE = 'data-state/success';
export const ERROR_DATA_STATE = 'data-state/error';
export const LOADING_DATA_STATE = 'data-state/loading';

export const dataStates = [
    INITIAL_DATA_STATE,
    SUCCESS_DATA_STATE,
    ERROR_DATA_STATE,
    LOADING_DATA_STATE,
] as const;

export type DataState = (typeof dataStates)[number];
